module.exports = __webpack_public_path__ + "static/img/zwfz-bg.f116460.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/zwfz-bg.png
// module id = 1fCY
// module chunks = 96